import React, { useRef } from 'react';

import { useLegoComponents } from 'client/common/hooks';
import cn from 'utils/cn';

import { IOnloadPopupProps } from './OnloadPopup.types';

import './OnloadPopup.css';

const b = cn('onload-popup');
const pageClass = cn('b-page');

export default function OnloadPopup({ isOpen, children }: IOnloadPopupProps) {
    const { Popup } = useLegoComponents();
    const rootRef = useRef<HTMLDivElement>(null);

    return (
        <div className={pageClass('overlay', { visible: 'no' })} ref={rootRef}>
            <div className={b()}>
                <Popup
                    className={b('popup2')}
                    target="anchor"
                    theme="normal"
                    visible={isOpen}
                    anchor={rootRef}
                    >
                    { children }
                </Popup>
            </div>
        </div>
    );
}
